// extracted by mini-css-extract-plugin
module.exports = {"baseForm":"base-form-module--baseForm--1_7OW"};